import type { StackProps as MuiStackProps } from "@mui/material/Stack";

import MuiStack from "@mui/material/Stack";
import { forwardRef, ReactNode } from "react";

export interface StackProps
    extends Pick<
        MuiStackProps,
        "className" | "direction" | "gap" | "justifyContent" | "alignItems"
    > {
    component?: "div" | "span";
    children: ReactNode;
}

export const Stack = forwardRef<HTMLDivElement, StackProps>(
    ({ children, component = "div", ...rest }, ref) => (
        <MuiStack component={component} ref={ref} useFlexGap {...rest}>
            {children}
        </MuiStack>
    ),
);

Stack.displayName = "Stack";
